import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';

import { Modal, Button, Progress, Card, Statistic, Timeline, Tabs } from 'antd';
import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.css';


const mulu = {
  'kdf3': { path: 'kdf3' },
  'kdf3-刀盘总成':
    { path: 'kdf3-dpzc', life: 87, cycle: 3, start: '上次保养 2020-10-22 ', end: '下次保养 2021-01-22 ' },
  'kdf3-供纸系统总成':
    { path: 'kdf3-gzxtzc', life: 75, cycle: 3, start: '上次保养 2021-07-22 ', end: '下次保养 2021-10-22 ' },
  'kdf3-提丝臂总成':
    { path: 'kdf3-tsbzc', life: 80, cycle: 6, start: '上次保养 2020-10-22 ', end: '下次保养 2021-04-22 ' },
  'kdf3-烟舌总成':
    { path: 'kdf3-yszc', life: 63, cycle: 1, start: '上次保养 2021-11-22 ', end: '下次保养 2021-12-22 ' },
}

// console.log(escape('kdf3-刀盘总成'))


function Show() {

  const showEl = useRef();
  const showElMini = useRef();
  const { ID } = useParams();

  const [scene, setScene] = useState();
  const [controls, setControls] = useState();
  const [canvasW, setCanvasW] = useState(0);
  const [canvasH, setCanvasH] = useState(0);
  const [miniScene, setMiniScene] = useState();
  const [miniControls, setMiniControls] = useState();
  const [miniCW, setMiniCW] = useState(0);
  const [miniCH, setMiniCH] = useState(0);

  const [camera, setCamera] = useState();
  const [renderer, setRenderer] = useState();
  const [info, setInfo] = useState('');
  const [pickObj, setPickObj] = useState();
  const [pickMaterial, setPickMaterial] = useState();


  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };



  const raycaster = new THREE.Raycaster();
  raycaster.layers.set(1);
  const mouse = new THREE.Vector2();

  const SMaterial = new THREE.MeshPhongMaterial({
    // color: 0x363f4f,
    color: 0xE25910,
    specular: 0x111111,
    reflectivity: 1,
    shininess: 150,
  });

  const stats = new Stats();
  // stats.domElement.style.left = null
  stats.domElement.style.top = null
  // stats.domElement.style.right = '0px'
  stats.domElement.style.bottom = '0px'

  const INH = window.innerHeight;

  const { TabPane } = Tabs;


  // useEffect(() => {
  //   // console.log(ID)
  //   if (ID && scene) {
  //     // console.log(scene)
  //     ReLoadModel(ID)
  //   } else if (scene) {
  //     ReLoadModel('kdf3')
  //   }
  // }, [ID]);



  useEffect(() => {
    if (showEl.current) {
      console.log('[init]')
      init();
    }
  }, []);



  useEffect(() => {
    if (isModalVisible && showElMini.current) {
      console.log('[showElMini]')

      let cv = showElMini.current.getElementsByTagName("canvas");
      if (cv.length > 0) {
        //清空
        miniScene.children.forEach(item => {
          if (item.type === 'Group') {
            miniScene.remove(item);
          }
        });
        // controls重置
        miniControls.reset();
        miniControls.update();

        LoadModel(miniScene, info, miniCW, miniCH, 'miniCamera', 600);

      } else {

        let miniCW = showElMini.current.clientWidth;
        let miniCH = showElMini.current.clientHeight;
        setMiniCW(miniCW)
        setMiniCH(miniCH)

        let miniScene = new THREE.Scene()
        let miniRenderer = new THREE.WebGLRenderer({ antialias: true });

        let S = 20;
        let miniCamera = new THREE.OrthographicCamera(miniCW / - S, miniCW / S, miniCH / S, miniCH / - S, 1, 1000);
        miniCamera.name = 'miniCamera'
        miniCamera.position.z = 500;
        miniCamera.position.x = 0;
        miniCamera.position.y = 200;


        miniRenderer.physicallyCorrectLights = true;
        miniRenderer.outputEncoding = THREE.sRGBEncoding;
        miniRenderer.setClearColor(0x99cccc);
        //像素
        miniRenderer.setPixelRatio(window.devicePixelRatio);
        miniRenderer.setSize(miniCW, miniCH);


        //环境光
        let ablight = new THREE.AmbientLight(0xFFFFFF, 2);
        miniScene.add(ablight);

        let pmremGenerator = new THREE.PMREMGenerator(miniRenderer);
        pmremGenerator.compileEquirectangularShader();

        //HDR 环境光
        new RGBELoader()
          .setDataType(THREE.UnsignedByteType)
          .load(process.env.PUBLIC_URL +
            '/hdr/1k.hdr', function (texture) {

              let envMap = pmremGenerator.fromEquirectangular(texture).texture
              envMap.isPmremTexture = true
              pmremGenerator.dispose()

              // 这两个可以分开设置
              miniScene.environment = envMap  // 给场景添加环境光效果
              // miniScene.background = envMap // 给场景添加背景图
            })

        // let light = new THREE.DirectionalLight(0xFFFFFF, 1 * Math.PI);
        // light.position.set(-150, 50, 0);
        // miniCamera.add(light);

        miniScene.add(miniCamera);

        let miniControls = new OrbitControls(miniCamera, miniRenderer.domElement);
        miniControls.autoRotateSpeed = 4;
        miniControls.autoRotate = true;
        miniControls.saveState();
        miniControls.update();

        LoadModel(miniScene, info, miniCW, miniCH, 'miniCamera', 600);

        miniRenderer.render(miniScene, miniCamera);
        showElMini.current.appendChild(miniRenderer.domElement);

        setMiniControls(miniControls);
        setMiniScene(miniScene);

        let miniAnimate = function () {
          requestAnimationFrame(miniAnimate);

          miniControls.update();

          miniRenderer.render(miniScene, miniCamera);
        };

        miniAnimate();
      }

    }

  }, [isModalVisible]);



  useEffect(() => {
    // console.log('addEventListener')
    if (renderer) {
      renderer.domElement.addEventListener("dblclick", dblclick);
      renderer.domElement.addEventListener("touchstart", touchstart);
      return () => {
        renderer.domElement.removeEventListener("dblclick", dblclick);
        renderer.domElement.removeEventListener("touchstart", touchstart);
      };
    }
  });








  //双击鼠标左键
  const dblclick = event => {

    let rect = renderer.domElement.getBoundingClientRect();

    mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    // console.log('mouse', mouse)
    ToPick(mouse);
  };


  //触摸事件
  const touchstart = event => {
    let count = 0;
    if (event.touches.length === 1) {

      count++;
      setTimeout(function () {
        count = 0;
      }, 500);
      if (count > 1) {
        //console.log('双击')
        count = 0;

        let touch2 = event.touches[0];
        let rect = renderer.domElement.getBoundingClientRect();
        mouse.x = ((touch2.pageX - rect.left) / rect.width) * 2 - 1;
        mouse.y = -((touch2.pageY - rect.top) / rect.height) * 2 + 1;

        // console.log('mouse', mouse)
        ToPick(mouse);
      }

    }
  };


  const ToPick = (mouse) => {
    //TODO 鼠标拾取

    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(scene.children, true);
    // console.log(intersects)

    // 恢复上次pick
    if (pickObj) {
      console.log('恢复上次pick')
      pickObj.material = pickMaterial;
      pickObj.material.needsUpdate = true;
    }

    if (intersects.length > 0) {
      //选择第一个 objsct type ==> Mesh
      intersects.some(element => {
        if (element.object.type === 'Mesh') {
          switchModel(element.object.name)
          return true;
        }
      });

    } else {
      setInfo('')
      setPickObj('')
      setPickMaterial('')
    }

  }


  //切换模型
  const ReLoadModel = (name) => {

    // scene.children.pop()
    // 清除children type: "Group"
    scene.children.forEach(item => {
      if (item.type === 'Group') {
        scene.remove(item);
      }
    });


    // 清除信息
    setInfo('')
    setPickObj('')
    setPickMaterial('')

    // controls重置
    controls.reset();
    controls.update();

    //加载模型
    LoadModel(scene, name, canvasW, canvasH, 'OCamera', 600);

  }



  const LoadModel = (scene, modelName, canvasW, canvasH, cameraName, S) => {

    //change name
    let mlname = mulu[modelName]
    if (mlname) {
      modelName = mlname.path
    }

    // 路径解析
    let str = modelName.replace(/-/g, '/')
    let path = str.substring(0, str.lastIndexOf('/'));

    let loader = new GLTFLoader();
    loader.load(process.env.PUBLIC_URL +
      '/models/' + path + '/' + modelName + '.glb',
      (gltf) => {
        // called when the resource is loaded
        console.log('模型加载完成');
        // console.log('gltf', gltf)
        // console.log(gltf.scene)

        gltf.scene.children.forEach(item => {
          if (item.type === 'Mesh') {
            let edges = new THREE.EdgesGeometry(item.geometry, 80);


            // console.log(item.name)
            // 特殊处理外壳
            if (item.name === 'outline') {
              let line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({ color: 0xcccccc }));
              line.name = 'Gline'
              item.add(line)

              item.material.transparent = true
              item.material.opacity = 0.3
            } else {
              if (S < 1100) {
                let line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({ color: 0x333333 }));
                line.name = 'Gline'
                item.add(line)
              }

              item.layers.enable(1);
            }

          }
        });


        // 定位
        let box = new THREE.Box3().setFromObject(gltf.scene);
        let size = box.getSize(new THREE.Vector3()).length();
        let center = box.getCenter(new THREE.Vector3());

        gltf.scene.position.x += (gltf.scene.position.x - center.x);
        gltf.scene.position.y += (gltf.scene.position.y - center.y);
        gltf.scene.position.z += (gltf.scene.position.z - center.z);
        gltf.scene.name = 'GModels'
        scene.add(gltf.scene);

        // controls.maxDistance = size * 10;
        let camera = scene.getObjectByName(cameraName);
        if (camera) {
          camera.near = size / 100;
          camera.far = size * 100;
          camera.left = canvasW / (-S / size);
          camera.right = canvasW / (S / size);
          camera.top = canvasH / (S / size);
          camera.bottom = canvasH / (-S / size);
          // camera.lookAt(center);
          camera.updateProjectionMatrix();
        }

      },
      (xhr) => {
        // called while loading is progressing
        console.log(`${(xhr.loaded / xhr.total * 100)}% loaded`);
      },
      (error) => {
        // called when loading has errors
        console.error('An error happened', error);
      },
    );

  }


  const init = () => {

    let canvasW = showEl.current.clientWidth;
    let canvasH = showEl.current.clientHeight;
    setCanvasW(canvasW)
    setCanvasH(canvasH)

    // console.log('w:' + canvasW + '    h:' + canvasH)

    let scene = new THREE.Scene()
    let renderer = new THREE.WebGLRenderer({ antialias: true });
    // const camera = new THREE.PerspectiveCamera(100, canvasW / canvasH, 0.1, 1000);
    let S = 20;
    let camera = new THREE.OrthographicCamera(canvasW / - S, canvasW / S, canvasH / S, canvasH / - S, 1, 1000);
    camera.name = 'OCamera'

    setScene(scene);
    setCamera(camera);
    setRenderer(renderer);


    renderer.physicallyCorrectLights = true;
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.setClearColor(0x7D9EC0);
    //像素
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(canvasW, canvasH);


    camera.position.z = 500;
    camera.position.x = 0;
    camera.position.y = 200;


    //环境光
    let ablight = new THREE.AmbientLight(0xFFFFFF, 2);
    scene.add(ablight);

    let pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    //HDR 环境光
    new RGBELoader()
      .setDataType(THREE.UnsignedByteType)
      .load(process.env.PUBLIC_URL +
        '/hdr/1k.hdr', function (texture) {

          let envMap = pmremGenerator.fromEquirectangular(texture).texture
          envMap.isPmremTexture = true
          pmremGenerator.dispose()

          // 这两个可以分开设置
          scene.environment = envMap  // 给场景添加环境光效果
          // scene.background = envMap // 给场景添加背景图
        })



    let light = new THREE.DirectionalLight(0xFFFFFF, 3 * Math.PI);
    light.position.set(-150, 50, 0);

    // light.target = targetObject;
    // light.target.position.set(0, 0, -100);

    camera.add(light);

    scene.add(camera);


    const controls = new OrbitControls(camera, renderer.domElement);
    controls.update();
    setControls(controls);

    // if (ID) {
    //   LoadModel(scene, ID, canvasW, canvasH, 'OCamera', 1800);
    // } else {
    //   LoadModel(scene, 'kdf3', canvasW, canvasH, 'OCamera', 1800);
    // }
    LoadModel(scene, 'kdf3', canvasW, canvasH, 'OCamera', 1800);

    renderer.render(scene, camera);
    showEl.current.appendChild(renderer.domElement);

    // 显示帧数
    showEl.current.appendChild(stats.dom);

    let animate = function () {
      // console.log('animate')
      requestAnimationFrame(animate);
      if (renderer) {
        renderer.render(scene, camera);
      }
      if (stats) {
        stats.update();
      }
    }

    animate()

  }


  const switchModel = (name) => {

    let objs = scene.getObjectByName('GModels');
    objs && objs.children.forEach(item => {
      if (item.name === name) {

        //保存当前pick
        setPickObj(item)
        setPickMaterial(item.material)
        setInfo(item.name)

        item.material = SMaterial;
        item.material.needsUpdate = true;

        showModal();
      }
    })
  }


  const onTabChange = (key) => {
    if (key === "2") {
      console.log("load 2")
      let cv = showElMini.current.getElementsByTagName("canvas");
      if (cv.length > 0) {
        //清空
        miniScene.children.forEach(item => {
          if (item.type === 'Group') {
            miniScene.remove(item);
          }
        });
        // controls重置
        miniControls.reset();
        miniControls.update();

        LoadModel(miniScene, 'max', miniCW, miniCH, 'miniCamera', 1000);
      }
    } else {
      console.log("load 1")
      let cv = showElMini.current.getElementsByTagName("canvas");
      if (cv.length > 0) {
        //清空
        miniScene.children.forEach(item => {
          if (item.type === 'Group') {
            miniScene.remove(item);
          }
        });
        // controls重置
        miniControls.reset();
        miniControls.update();

        LoadModel(miniScene, info, miniCW, miniCH, 'miniCamera', 600);
      }
    }
  }


  return (
    <div >

      <main >
        <div >

          <div style={{
            position: 'absolute', left: '50%', marginLeft: -150,
            width: 300, fontSize: 24, color: 'white',
            userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none',
            textAlign: 'center'
          }}>
            {/* {ID ?
              <>
                {ID}
              </>
              :
              ''
            } */}

          </div>

          <div
            id="canvas"
            style={{ width: '100%', height: INH, background: '#888' }}
            ref={showEl}
          />

        </div>
      </main>

      {ID && ID === 'max' ?
        <Modal title={<div style={{ margin: -5 }}>{info}</div>} visible={isModalVisible}
          // closable={false}
          onCancel={handleOk}
          onOk={handleOk}
          maskClosable={false}
          style={{ top: 10, float: 'right', right: 10 }}
          width={600}
          footer={null}
        >
          <div
            id="minicanvas"
            style={{ width: '100%', height: 220, background: '#888', marginTop: -20 }}
            ref={showElMini}
          />
          <Tabs defaultActiveKey="1" style={{ marginTop: -10 }} onChange={onTabChange}>
            <TabPane tab={<div style={{ marginTop: 5, marginBottom: -5 }}>状态</div>} key="1" style={{ marginTop: -10 }} className='row'>

              <div className="col" >
                <div>
                  模块剩余寿命：
                  <Progress percent={mulu[info] ? mulu[info].life : 80} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>
                <Card>
                  <Statistic
                    style={{ margin: -15 }}
                    title="保养周期："
                    value={mulu[info] ? mulu[info].cycle : 3}
                    precision={1}
                    valueStyle={{ color: '#cf1322' }}
                    prefix={<>&darr;</>}
                    suffix="个月"
                  />
                </Card>
                <Timeline style={{ marginBottom: -70, marginTop: 10, height: 105 }}>
                  <Timeline.Item style={{ marginBottom: -20 }}>{mulu[info] ? mulu[info].start : '上次保养 2020-10-22'} </Timeline.Item>
                  <Timeline.Item >{mulu[info] ? mulu[info].end : '下次保养 2021-01-22'} </Timeline.Item>
                </Timeline>
              </div>
              <div className="col" style={{ textAlign: 'center' }} >
                <div style={{ position: 'absolute', marginLeft: 210, textAlign: 'right' }} >健康指数<br></br>80%</div>
                <img src={process.env.PUBLIC_URL + '/images/radar.svg'} height={170} ></img>
              </div>


            </TabPane>

            <TabPane tab={<div style={{ marginTop: 5, marginBottom: -5 }}>备件</div>} key="2" style={{ marginTop: -10 }}>
              <div className='row mt-1'>
                <div className='col-3' >叉形架O形圈</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

                <div className='col-3' >滚针轴承</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

                <div className='col-3' >尼龙套</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

                <div className='col-3' >调心球轴承</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

                <div className='col-3' >摩擦轮</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

                <div className='col-3' >摩擦轮滚针轴承</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

                <div className='col-3' >进刀轴</div>
                <div className='col-9' >
                  剩余寿命：
                  <Progress percent={Math.floor(Math.random() * 60) + 40} strokeColor="#52c41a"
                    status="active" steps={10} style={{ marginLeft: 10 }} />
                </div>

              </div>
            </TabPane>
          </Tabs>



        </Modal>
        :
        <Modal title={<div style={{ margin: -5 }}>{info}</div>} visible={isModalVisible}
          closable={false}
          onOk={handleOk}
          maskClosable={false}
          style={{ top: 10, float: 'right', right: 10 }}
          width={300}
          footer={[
            <Button key="sure" type="primary" onClick={handleOk} style={{ marginTop: -10, marginBottom: -10 }}>
              确定
            </Button>
          ]}>
          <div
            id="minicanvas"
            style={{ width: '100%', height: 220, background: '#888', marginTop: -20 }}
            ref={showElMini}
          />
          剩余寿命：
          <Progress percent={mulu[info] ? mulu[info].life : 80} strokeColor="#52c41a" status="active" steps={10} style={{ marginLeft: 10 }} />
          {/* <p>保养周期：</p> */}
          <Card>
            <Statistic
              style={{ margin: -15 }}
              title="保养周期："
              value={mulu[info] ? mulu[info].cycle : 3}
              precision={1}
              valueStyle={{ color: '#cf1322' }}
              prefix={<>&darr;</>}
              suffix="个月"
            />
          </Card>

          <Timeline style={{ marginBottom: -70, marginTop: 10 }}>
            <Timeline.Item style={{ marginBottom: -10 }}>{mulu[info] ? mulu[info].start : '上次保养 2020-10-22'} </Timeline.Item>
            <Timeline.Item >{mulu[info] ? mulu[info].end : '下次保养 2021-01-22'} </Timeline.Item>
          </Timeline>

        </Modal>}



    </div>
  )
}

export default Show;
